export const PDF_LOADING = 'PDF_LOADING';
export const PDF_LOADED = 'PDF_LOADED';
export const PDF_ERROR = 'PDF_ERROR';